module.exports = __webpack_public_path__ + "static/media/furniture.eb7abe97.png";